import * as React from "react";
import { Router, Route, Switch } from "react-router-dom";
import createHistory from "history/createBrowserHistory";
import { LocaleProvider } from "antd";
import pt_BR from "antd/lib/locale-provider/pt_BR";
import { LoadStaticScripts } from "./StaticScripts";
import { Suspense, useEffect } from "react";
import Loading from "./components/common/Loading";
import { Institucional } from "./pages";
import { ServiceProvider } from "./services/provider/Service.provider";
import { SecureProvider } from "./services/provider/Secure.provider";
import { GlobalProvider } from "./services/provider/Global.provider";
import TagManager from "react-gtm-module";
import * as ReactGA from "react-ga";

import "./components/theme/less/theme.less";
import "src/components/theme/scss/common.scss";
import "./App.css";

const history = createHistory();
LoadStaticScripts(history);

const App = () => {
  useEffect(() => {
    TagManager.initialize({ gtmId: "GTM-P9QV5PH" });
    ReactGA.initialize("UA-128076428-2,", { debug: false });
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  return (
    <Router history={history}>
      <Suspense fallback={<Loading />}>
        <Switch>
          <Route path="/" component={Institucional} />
        </Switch>
      </Suspense>
    </Router>
  );
};

export default (props: any) => (
  <>
    <LocaleProvider locale={pt_BR}>
      <ServiceProvider>
        <SecureProvider>
          <GlobalProvider>
            <App {...props} />
          </GlobalProvider>
        </SecureProvider>
      </ServiceProvider>
    </LocaleProvider>
  </>
);



// WEBPACK FOOTER //
// ./src/App.tsx